module.exports = {
  "country": "CH",
  "artist": "Arlette Zola",
  "song": "Amour on t'aime",
  "year": "1982",
  "place": "3",
  "spotify": ""
};